module.exports = __webpack_public_path__ + "static/media/fourBg.ff0061cd.png";